import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import './Content.css';
import Home  from '../home/Home';
import HomeUser from "../home/HomeUser";
import About from './About';
import Login from '../account/Login';
import Restore from '../account/Restore';
import NewPass from '../account/NewPass';
import UserAdd  from '../user/UserAdd';
import UserEdit from '../user/UserEdit';
import UserList from '../user/UserList';
import UserView from '../user/UserView';
import Expodat from '../event/Expodat';
import EventAdd  from '../event/EventAdd';
import EventList from '../event/EventList';
import EventView from '../event/EventView';
import EventEdit from '../event/EventEdit';
import StickerAdd from '../sticker/StickerAdd';
import StickerEdit from '../sticker/StickerEdit';
import CategoryAdd from '../category/CategoryAdd';
import CategoryEdit from '../category/CategoryEdit';
import ExhibitorAdd from '../exhibitor/ExhibitorAdd';
import ExhibitorList from '../exhibitor/ExhibitorList';
import ExhibitorView from '../exhibitor/ExhibitorView';
import ExhibitorEditMain from '../exhibitor/ExhibitorEditMain';
import ExhibitorEditFile from '../exhibitor/ExhibitorEditFile';
import ExhibitorEditTexts from '../exhibitor/ExhibitorEditTexts';
import ExhibitorEditBrief from '../exhibitor/ExhibitorEditBrief';
import ExhibitorEditAbout from '../exhibitor/ExhibitorEditAbout';
import ExhibitorEditDescr from '../exhibitor/ExhibitorEditDescr';
import ExhibitorEditLinks from '../exhibitor/ExhibitorEditLinks';
import ExhibitorEditContacts from '../exhibitor/ExhibitorEditContacts';
import ExhibitorEditStickers from '../exhibitor/ExhibitorEditStickers';
import ExhibitorEditCategories from '../exhibitor/ExhibitorEditCategories';
import ExhibitorListByEvent from "../exhibitor/ExhibitorListByEvent";
import CounterAdd from "../event/CounterAdd";
import ActivityAdd from "../exhibitor/activity/ActivityAdd";
import ActivityEdit from "../exhibitor/activity/ActivityEdit";
import Preset from "../preset/Preset";
import CountryList from "../country/CountryList";

const Content = () => {
    const token = useSelector(state => state.auth.token);

	return (
	    <div className='Content'>
            <Routes>
                <Route path='/cabinet/about' element={<About/>}/>
                <Route path='/cabinet' element={token ? <Home/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/active' element={token ? <HomeUser archive={false}/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/archive' element={token ? <HomeUser archive={true}/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/login' element={token ? <Navigate replace to='/cabinet'/> : <Login/>}/>
                <Route path='/cabinet/login/email/:email' element={token ? <Navigate replace to='/cabinet'/> : <Login/>}/>
                <Route path='/cabinet/restore' element={token ? <Navigate replace to='/cabinet'/> : <Restore/>}/>
                <Route path='/cabinet/restore/email/:email' element={token ? <Navigate replace to='/cabinet'/> : <Restore/>}/>
                <Route path='/cabinet/newpass' element={<NewPass/>}/>
                <Route path='/cabinet/newpass/email/:email' element={<NewPass/>}/>
                <Route path='/cabinet/newpass/email/:email/code/:code' element={<NewPass/>}/>

                <Route path='/cabinet/useradd' element={token ? <UserAdd/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/useredit' element={token ? <UserEdit/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/userlist' element={token ? <UserList/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/userview/:id' element={token ? <UserView/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/userview/:id/action/:action' element={token ? <UserView/> : <Navigate replace to='/cabinet/login'/>}/>

                <Route path='/cabinet/preset/:id' element={token ? <Preset/> : <Navigate replace to='/cabinet/login'/>}/>

                <Route path='/cabinet/eventadd' element={token ? <EventAdd/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/eventlist' element={token ? <EventList/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/eventedit' element={token ? <EventEdit/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/eventview/:id' element={token ? <EventView/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/eventview/:id/action/:action' element={token ? <EventView/> : <Navigate replace to='/cabinet/login'/>}/>

                <Route path='/cabinet/stickeradd' element={token ? <StickerAdd/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/stickeredit' element={token ? <StickerEdit/> : <Navigate replace to='/cabinet/login'/>}/>

                <Route path='/cabinet/categoryadd' element={token ? <CategoryAdd/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/categoryedit' element={token ? <CategoryEdit/> : <Navigate replace to='/cabinet/login'/>}/>

                <Route path='/cabinet/activityadd' element={token ? <ActivityAdd/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/activityedit' element={token ? <ActivityEdit/> : <Navigate replace to='/cabinet/login'/>}/>

                <Route path='/cabinet/exhibitoradd'  element={token ? <ExhibitorAdd/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoradd/:toevent'  element={token ? <ExhibitorAdd/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitorlist' element={token ? <ExhibitorList/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitorlistbyevent/:event' element={token ? <ExhibitorListByEvent/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitorview/:id' element={token ? <ExhibitorView/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitorview/:id/action/:action' element={token ? <ExhibitorView/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditfile' element={token ? <ExhibitorEditFile/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditfile/:id' element={token ? <ExhibitorEditFile/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditmain' element={token ? <ExhibitorEditMain/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoredittexts' element={token ? <ExhibitorEditTexts/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditbrief' element={token ? <ExhibitorEditBrief/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditabout' element={token ? <ExhibitorEditAbout/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditdescr' element={token ? <ExhibitorEditDescr/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditlinks' element={token ? <ExhibitorEditLinks/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditcontacts' element={token ? <ExhibitorEditContacts/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditstickers' element={token ? <ExhibitorEditStickers/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/exhibitoreditcategories' element={token ? <ExhibitorEditCategories/> : <Navigate replace to='/cabinet/login'/>}/>

                <Route path='/cabinet/counteradd/:id' element={token ? <CounterAdd/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/expodat/:id' element={token ? <Expodat/> : <Navigate replace to='/cabinet/login'/>}/>
                <Route path='/cabinet/countrylist' element={token ? <CountryList/> : <Navigate replace to='/cabinet/login'/>}/>

                <Route path='*' element={<Navigate replace to='/cabinet'/>} />
            </Routes>
        </div>
	);
};

export default Content;
